import get from 'lodash.get';

// Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Types
import { AppState } from 'services/types';
import {
    MyTimesheetEntryDate,
    MyTimesheetEntryEndTime,
    MyTimesheetEntryStartTime
} from 'services/myTimesheetEntries/types';

// Global Selectors
import { selectMyTimesheetEntriesGroupedByDate } from 'services/myTimesheetEntries/selectors';
// @ts-ignore
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

// Global Utils
import timeRangesOverlap from 'utils/time-ranges-overlap';

// Local Types
import { OwnProps } from './types';

const selectDate = (
    _state: AppState,
    props: OwnProps
): MyTimesheetEntryDate | undefined => props.date;
const selectEndTime = (
    state: AppState,
    props: OwnProps
): MyTimesheetEntryEndTime | undefined => props.endTime;
const selectStartTime = (
    state: AppState,
    props: OwnProps
): MyTimesheetEntryStartTime | undefined => props.startTime;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const makeSelectMyTimesheetEntryAlreadyExists = () =>
    createDeepEqualSelector(
        [
            selectMyTimesheetEntriesGroupedByDate,
            selectDate,
            selectStartTime,
            selectEndTime,
            makeSelectQueryStringValue('myTimesheetEntryUuid')
        ],
        (
            myTimesheetEntriesGroupedByDate,
            dateProp,
            startTimeProp,
            endTimeProp,
            queryStringMyTimesheetEntryUuidState
        ): boolean => {
            if (!dateProp || !startTimeProp || !endTimeProp) {
                return false;
            }

            const myTimesheetEntriesByDate = get(
                myTimesheetEntriesGroupedByDate,
                dateProp
            );

            // No my timesheet entries exist for the specified date
            if (!myTimesheetEntriesByDate) {
                return false;
            }

            // Check if time range overlaps with any existing my timesheet entries
            return myTimesheetEntriesByDate.some(
                ({ uuid, startTime, endTime }): boolean => {
                    // Check if entry uuid matches the selected entry
                    if (uuid === queryStringMyTimesheetEntryUuidState) {
                        return false;
                    }
                    return timeRangesOverlap(
                        startTimeProp,
                        endTimeProp,
                        startTime,
                        endTime
                    );
                }
            );
        }
    );

export { makeSelectMyTimesheetEntryAlreadyExists };
